<template>
    <div id="cpi_code_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="cpiCodeHeader" v-if="$route.params.id > 0">Update Cpi Code</span>
                    <span class="page-title" id="cpiCodeHeader" v-else>Add Cpi Code</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackCpiCodeList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content cpi-code-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CpiCodeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label">Status</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="status">Active
                                                    <input type="radio" v-model="status" :value='1' id="status" name="status">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="status1"> Inactive
                                                    <input type="radio" v-model="status" :value='0' id="status1" name="status">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createCpiCodeBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCpiCode" >
                                    <i class="f-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createCpiCodeBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCpiCode" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCpiCodeBtn"  v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCpiCode(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCpiCodeBtn" class="btn btn-tertiary" v-on:click.prevent="BackCpiCodeList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "CpiCodeCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update CPI Code | " +process.env.COPYRIGHT_NAME : "Create CPI Code | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    status: '1',
    loading:false,
    code_error_msg: "",
    name_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_cpi_code') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadCpiCode();
            }
        }, 100);
  },
  methods: {

    BackCpiCodeList() {
      var self = this;
      self.$router.push("/cpicode/list");
    },

    CreateCpiCode(flag) {
        var self = this;

        self.code = self.code.trim();
        self.name = self.name.trim();

        self.code_error_msg = "";
        self.name_error_msg = "";

        if (!self.code || self.code == null || self.code == "") {
            self.code_error_msg = "Code Required.";
        }

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
        }

        if (self.code_error_msg == "" && self.name_error_msg == "") {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createCpiCodeBtn").val("Updating ...");
                $("#createCpiCodeBtn").prop("disabled", true);
                $("#cancelCpiCodeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCpiCodeBtn").val("Saving ...");
                    $("#createCpiCodeBtn").prop("disabled", true);
                    $("#createAndContinueCpiCodeBtn").prop("disabled", true);
                    $("#cancelCpiCodeBtn").prop("disabled",true);

                }else{

                    $("#createCpiCodeBtn").val("Saving ...");
                    $("#createCpiCodeBtn").prop("disabled", true);
                    $("#createAndContinueCpiCodeBtn").prop("disabled", true);
                    $("#cancelCpiCodeBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/cpicode/create",
                type: "POST",
                data: {code: self.code,id: segments[3], name: self.name, status:self.status},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createCpiCodeBtn").val("Update");
                        $("#createCpiCodeBtn").prop("disabled", false);
                        $("#cancelCpiCodeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCpiCodeBtn").val("Save and Continue");
                            $("#createCpiCodeBtn").prop("disabled", false);
                            $("#createAndContinueCpiCodeBtn").prop("disabled", false);
                            $("#cancelCpiCodeBtn").prop("disabled",false);

                        }else{

                            $("#createCpiCodeBtn").val("Save");
                            $("#createCpiCodeBtn").prop("disabled", false);
                            $("#createAndContinueCpiCodeBtn").prop("disabled", false);
                            $("#cancelCpiCodeBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.code = "";
                            self.name = "";

                        }else{
                            self.$router.push("/cpicode/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createCpiCodeBtn").val("Update");
                        $("#createCpiCodeBtn").prop("disabled", false);
                        $("#cancelCpiCodeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {
                            
                            $("#createAndContinueCpiCodeBtn").val("Save and Continue");
                            $("#createCpiCodeBtn").prop("disabled", false);
                            $("#createAndContinueCpiCodeBtn").prop("disabled", false);
                            $("#cancelCpiCodeBtn").prop("disabled",false);

                        }else{

                            $("#createCpiCodeBtn").val("Save");
                            $("#createCpiCodeBtn").prop("disabled", false);
                            $("#createAndContinueCpiCodeBtn").prop("disabled", false);
                            $("#cancelCpiCodeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'cpi-code-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadCpiCode() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/cpicode/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.name = data.content.name;
                    self.status = data.content.status;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'cpi-code-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/CpiCodeCreate.vue